import {
	getOrderListDeliveryStatusLabel,
	getOrderListPaymentStatusLabel,
	ORDER_LIST_STATUS_COMPOSITION_LABELS,
} from './orderListStatusFilterOptions';

export const ORDER_LIST_STATUS_DRILLDOWN = {
	APPROVAL_APPROVED: 'approvalApproved',
	APPROVAL_PENDING: 'approvalPending',
	APPROVAL_REJECTED: 'approvalRejected',
	ORDER_COMPLETED: 'order.completed',
	ORDER_NOT_COMPLETED: 'order.notCompleted',
	NOT_COMPLETED_FULFILLMENT_IN_PROGRESS: 'order.notCompleted.fulfillmentInProgress',
	NOT_COMPLETED_PENDING_VERIFICATION: 'order.notCompleted.pendingVerification',
};

export const NOT_COMPLETED_SUB_BRANCH_LABELS = {
	fulfillmentInProgress: '履约中',
	pendingVerification: '履约完成待核验',
};

export const buildPaymentStatusDrillKey = (statusValue) => `payment.${statusValue}`;

export const buildPaymentCompositionDrillKey = (statusValue, compositionKey) => `payment.${statusValue}.${compositionKey}`;

export const buildDeliveryStatusDrillKey = (statusValue) => `delivery.${statusValue}`;

export const buildDeliveryCompositionDrillKey = (statusValue, compositionKey) => `delivery.${statusValue}.${compositionKey}`;

export const buildBranchPaymentStatusDrillKey = (branch, statusValue) => `order.${branch}.payment.${statusValue}`;

export const buildBranchPaymentCompositionDrillKey = (branch, statusValue, compositionKey) =>
	`order.${branch}.payment.${statusValue}.${compositionKey}`;

export const buildBranchDeliveryStatusDrillKey = (branch, statusValue) => `order.${branch}.delivery.${statusValue}`;

export const buildBranchDeliveryCompositionDrillKey = (branch, statusValue, compositionKey) =>
	`order.${branch}.delivery.${statusValue}.${compositionKey}`;

export const buildNotCompletedSubBranchDrillKey = (subBranchKey) => `order.notCompleted.${subBranchKey}`;

export const buildNotCompletedSubBranchPaymentStatusDrillKey = (subBranchKey, statusValue) =>
	`order.notCompleted.${subBranchKey}.payment.${statusValue}`;

export const buildNotCompletedSubBranchPaymentCompositionDrillKey = (subBranchKey, statusValue, compositionKey) =>
	`order.notCompleted.${subBranchKey}.payment.${statusValue}.${compositionKey}`;

export const buildNotCompletedSubBranchDeliveryStatusDrillKey = (subBranchKey, statusValue) =>
	`order.notCompleted.${subBranchKey}.delivery.${statusValue}`;

export const buildNotCompletedSubBranchDeliveryCompositionDrillKey = (subBranchKey, statusValue, compositionKey) =>
	`order.notCompleted.${subBranchKey}.delivery.${statusValue}.${compositionKey}`;

export const FULFILLMENT_IN_PROGRESS_AXIS_BUCKET_LABELS = {
	paymentComplete: '支付完成',
	paymentIncomplete: '支付未完成',
	deliveryComplete: '物流完成',
	deliveryIncomplete: '物流未完成',
};

export const buildFulfillmentInProgressPaymentCompleteDrillKey = () =>
	'order.notCompleted.fulfillmentInProgress.paymentComplete';

export const buildFulfillmentInProgressPaymentIncompleteDrillKey = () =>
	'order.notCompleted.fulfillmentInProgress.paymentIncomplete';

export const buildFulfillmentInProgressPaymentIncompleteStatusDrillKey = (statusValue) =>
	`order.notCompleted.fulfillmentInProgress.paymentIncomplete.payment.${statusValue}`;

export const buildFulfillmentInProgressPaymentIncompleteCompositionDrillKey = (statusValue, compositionKey) =>
	`order.notCompleted.fulfillmentInProgress.paymentIncomplete.payment.${statusValue}.${compositionKey}`;

export const buildFulfillmentInProgressDeliveryCompleteDrillKey = () =>
	'order.notCompleted.fulfillmentInProgress.deliveryComplete';

export const buildFulfillmentInProgressDeliveryIncompleteDrillKey = () =>
	'order.notCompleted.fulfillmentInProgress.deliveryIncomplete';

export const buildFulfillmentInProgressDeliveryIncompleteStatusDrillKey = (statusValue) =>
	`order.notCompleted.fulfillmentInProgress.deliveryIncomplete.delivery.${statusValue}`;

export const buildFulfillmentInProgressDeliveryIncompleteCompositionDrillKey = (statusValue, compositionKey) =>
	`order.notCompleted.fulfillmentInProgress.deliveryIncomplete.delivery.${statusValue}.${compositionKey}`;

const BRANCH_DRILLDOWN_LABELS = {
	completed: '已完成',
	notCompleted: '未完成',
};

const formatBranchAxisDrillLabel = (branch, axisLabel, compositionLabel) => {
	const branchLabel = BRANCH_DRILLDOWN_LABELS[branch] ?? branch;
	if (compositionLabel) return `${branchLabel} · ${axisLabel} · ${compositionLabel}`;
	return `${branchLabel} · ${axisLabel}`;
};

const formatFulfillmentInProgressDrillLabel = (...parts) => ['未完成', '履约中', ...parts].join(' · ');

export const getOrderListStatusDrilldownLabel = (drillKey) => {
	const key = String(drillKey ?? '').trim();
	if (!key) return '';

	if (key === ORDER_LIST_STATUS_DRILLDOWN.APPROVAL_APPROVED) return '审批通过';
	if (key === ORDER_LIST_STATUS_DRILLDOWN.APPROVAL_PENDING) return '审批中';
	if (key === ORDER_LIST_STATUS_DRILLDOWN.APPROVAL_REJECTED) return '审批驳回';
	if (key === ORDER_LIST_STATUS_DRILLDOWN.ORDER_COMPLETED) return '已完成';
	if (key === ORDER_LIST_STATUS_DRILLDOWN.ORDER_NOT_COMPLETED) return '未完成';
	if (key === ORDER_LIST_STATUS_DRILLDOWN.NOT_COMPLETED_FULFILLMENT_IN_PROGRESS) return '未完成 · 履约中';
	if (key === ORDER_LIST_STATUS_DRILLDOWN.NOT_COMPLETED_PENDING_VERIFICATION) return '未完成 · 履约完成待核验';

	if (key === buildFulfillmentInProgressPaymentCompleteDrillKey()) {
		return formatFulfillmentInProgressDrillLabel(FULFILLMENT_IN_PROGRESS_AXIS_BUCKET_LABELS.paymentComplete);
	}
	if (key === buildFulfillmentInProgressPaymentIncompleteDrillKey()) {
		return formatFulfillmentInProgressDrillLabel(FULFILLMENT_IN_PROGRESS_AXIS_BUCKET_LABELS.paymentIncomplete);
	}
	if (key === buildFulfillmentInProgressDeliveryCompleteDrillKey()) {
		return formatFulfillmentInProgressDrillLabel(FULFILLMENT_IN_PROGRESS_AXIS_BUCKET_LABELS.deliveryComplete);
	}
	if (key === buildFulfillmentInProgressDeliveryIncompleteDrillKey()) {
		return formatFulfillmentInProgressDrillLabel(FULFILLMENT_IN_PROGRESS_AXIS_BUCKET_LABELS.deliveryIncomplete);
	}

	const fulfillmentPaymentIncompleteComp = key.match(
		/^order\.notCompleted\.fulfillmentInProgress\.paymentIncomplete\.payment\.([^.]+)\.([^.]+)$/,
	);
	if (fulfillmentPaymentIncompleteComp) {
		const [, statusValue, compositionKey] = fulfillmentPaymentIncompleteComp;
		const statusLabel = getOrderListPaymentStatusLabel(statusValue);
		const compositionLabel = ORDER_LIST_STATUS_COMPOSITION_LABELS[compositionKey] ?? compositionKey;
		return formatFulfillmentInProgressDrillLabel(
			FULFILLMENT_IN_PROGRESS_AXIS_BUCKET_LABELS.paymentIncomplete,
			statusLabel,
			compositionLabel,
		);
	}

	const fulfillmentPaymentIncompleteParent = key.match(/^order\.notCompleted\.fulfillmentInProgress\.paymentIncomplete\.payment\.([^.]+)$/);
	if (fulfillmentPaymentIncompleteParent) {
		return formatFulfillmentInProgressDrillLabel(
			FULFILLMENT_IN_PROGRESS_AXIS_BUCKET_LABELS.paymentIncomplete,
			getOrderListPaymentStatusLabel(fulfillmentPaymentIncompleteParent[1]),
		);
	}

	const fulfillmentDeliveryIncompleteComp = key.match(
		/^order\.notCompleted\.fulfillmentInProgress\.deliveryIncomplete\.delivery\.([^.]+)\.([^.]+)$/,
	);
	if (fulfillmentDeliveryIncompleteComp) {
		const [, statusValue, compositionKey] = fulfillmentDeliveryIncompleteComp;
		const statusLabel = getOrderListDeliveryStatusLabel(statusValue);
		const compositionLabel = ORDER_LIST_STATUS_COMPOSITION_LABELS[compositionKey] ?? compositionKey;
		return formatFulfillmentInProgressDrillLabel(
			FULFILLMENT_IN_PROGRESS_AXIS_BUCKET_LABELS.deliveryIncomplete,
			statusLabel,
			compositionLabel,
		);
	}

	const fulfillmentDeliveryIncompleteParent = key.match(/^order\.notCompleted\.fulfillmentInProgress\.deliveryIncomplete\.delivery\.([^.]+)$/);
	if (fulfillmentDeliveryIncompleteParent) {
		return formatFulfillmentInProgressDrillLabel(
			FULFILLMENT_IN_PROGRESS_AXIS_BUCKET_LABELS.deliveryIncomplete,
			getOrderListDeliveryStatusLabel(fulfillmentDeliveryIncompleteParent[1]),
		);
	}

	const notCompletedSubBranchPaymentComp = key.match(/^order\.notCompleted\.(fulfillmentInProgress|pendingVerification)\.payment\.([^.]+)\.([^.]+)$/);
	if (notCompletedSubBranchPaymentComp) {
		const [, subBranchKey, statusValue, compositionKey] = notCompletedSubBranchPaymentComp;
		const subBranchLabel = NOT_COMPLETED_SUB_BRANCH_LABELS[subBranchKey] ?? subBranchKey;
		const statusLabel = getOrderListPaymentStatusLabel(statusValue);
		const compositionLabel = ORDER_LIST_STATUS_COMPOSITION_LABELS[compositionKey] ?? compositionKey;
		return `未完成 · ${subBranchLabel} · ${statusLabel} · ${compositionLabel}`;
	}

	const notCompletedSubBranchPaymentParent = key.match(/^order\.notCompleted\.(fulfillmentInProgress|pendingVerification)\.payment\.([^.]+)$/);
	if (notCompletedSubBranchPaymentParent) {
		const [, subBranchKey, statusValue] = notCompletedSubBranchPaymentParent;
		const subBranchLabel = NOT_COMPLETED_SUB_BRANCH_LABELS[subBranchKey] ?? subBranchKey;
		return `未完成 · ${subBranchLabel} · ${getOrderListPaymentStatusLabel(statusValue)}`;
	}

	const notCompletedSubBranchDeliveryComp = key.match(/^order\.notCompleted\.(fulfillmentInProgress|pendingVerification)\.delivery\.([^.]+)\.([^.]+)$/);
	if (notCompletedSubBranchDeliveryComp) {
		const [, subBranchKey, statusValue, compositionKey] = notCompletedSubBranchDeliveryComp;
		const subBranchLabel = NOT_COMPLETED_SUB_BRANCH_LABELS[subBranchKey] ?? subBranchKey;
		const statusLabel = getOrderListDeliveryStatusLabel(statusValue);
		const compositionLabel = ORDER_LIST_STATUS_COMPOSITION_LABELS[compositionKey] ?? compositionKey;
		return `未完成 · ${subBranchLabel} · ${statusLabel} · ${compositionLabel}`;
	}

	const notCompletedSubBranchDeliveryParent = key.match(/^order\.notCompleted\.(fulfillmentInProgress|pendingVerification)\.delivery\.([^.]+)$/);
	if (notCompletedSubBranchDeliveryParent) {
		const [, subBranchKey, statusValue] = notCompletedSubBranchDeliveryParent;
		const subBranchLabel = NOT_COMPLETED_SUB_BRANCH_LABELS[subBranchKey] ?? subBranchKey;
		return `未完成 · ${subBranchLabel} · ${getOrderListDeliveryStatusLabel(statusValue)}`;
	}

	const branchPaymentComp = key.match(/^order\.(completed|notCompleted)\.payment\.([^.]+)\.([^.]+)$/);
	if (branchPaymentComp) {
		const [, branch, statusValue, compositionKey] = branchPaymentComp;
		const statusLabel = getOrderListPaymentStatusLabel(statusValue);
		const compositionLabel = ORDER_LIST_STATUS_COMPOSITION_LABELS[compositionKey] ?? compositionKey;
		return formatBranchAxisDrillLabel(branch, statusLabel, compositionLabel);
	}

	const branchPaymentParent = key.match(/^order\.(completed|notCompleted)\.payment\.([^.]+)$/);
	if (branchPaymentParent) {
		const [, branch, statusValue] = branchPaymentParent;
		return formatBranchAxisDrillLabel(branch, getOrderListPaymentStatusLabel(statusValue));
	}

	const branchDeliveryComp = key.match(/^order\.(completed|notCompleted)\.delivery\.([^.]+)\.([^.]+)$/);
	if (branchDeliveryComp) {
		const [, branch, statusValue, compositionKey] = branchDeliveryComp;
		const statusLabel = getOrderListDeliveryStatusLabel(statusValue);
		const compositionLabel = ORDER_LIST_STATUS_COMPOSITION_LABELS[compositionKey] ?? compositionKey;
		return formatBranchAxisDrillLabel(branch, statusLabel, compositionLabel);
	}

	const branchDeliveryParent = key.match(/^order\.(completed|notCompleted)\.delivery\.([^.]+)$/);
	if (branchDeliveryParent) {
		const [, branch, statusValue] = branchDeliveryParent;
		return formatBranchAxisDrillLabel(branch, getOrderListDeliveryStatusLabel(statusValue));
	}

	const paymentComp = key.match(/^payment\.([^.]+)\.([^.]+)$/);
	if (paymentComp) {
		const [, statusValue, compositionKey] = paymentComp;
		const statusLabel = getOrderListPaymentStatusLabel(statusValue);
		const compositionLabel = ORDER_LIST_STATUS_COMPOSITION_LABELS[compositionKey] ?? compositionKey;
		return `${statusLabel} · ${compositionLabel}`;
	}

	const paymentParent = key.match(/^payment\.([^.]+)$/);
	if (paymentParent) return getOrderListPaymentStatusLabel(paymentParent[1]);

	const deliveryComp = key.match(/^delivery\.([^.]+)\.([^.]+)$/);
	if (deliveryComp) {
		const [, statusValue, compositionKey] = deliveryComp;
		const statusLabel = getOrderListDeliveryStatusLabel(statusValue);
		const compositionLabel = ORDER_LIST_STATUS_COMPOSITION_LABELS[compositionKey] ?? compositionKey;
		return `${statusLabel} · ${compositionLabel}`;
	}

	const deliveryParent = key.match(/^delivery\.([^.]+)$/);
	if (deliveryParent) return getOrderListDeliveryStatusLabel(deliveryParent[1]);

	return key;
};
